export default __webpack_public_path__ + "static/media/dashboard.9515719e.svg";